

















import Vue from "vue";

export default Vue.extend({
  name: "StoreSelector",
  props: {
    storeId: {
      type: String,
      required: false,
      default: undefined,
    },
    stores: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedStore: this.storeId,
    };
  },
  methods: {
    select(): void {
      this.$emit("select", this.selectedStore);
    },
  },
});
